import { useState } from 'react';
import PropTypes from 'prop-types';

import './AddSampleModal.css';

import ModalBase from '../ModalBase';
import AddSampleBlock from '../../../components/AddSampleBlock/AddSampleBlock';

const addSampleModalStyles = {
	content: {
		maxHeight: '99%',
	},
};

/**
 * Adding new sample modal
 * @component
 */
const AddSampleModal = ({ isOpen, storage, onAddSample, onRequestClose }) => {
	const [lastLanguage, setLastLanguage] = useState('en');

	return (
		<ModalBase
			className="modal-addsample"
			isOpen={isOpen}
			style={addSampleModalStyles}
			onRequestClose={onRequestClose}
		>
			<AddSampleBlock
				lastLanguage={lastLanguage}
				storage={storage}
				onCancel={onRequestClose}
				onConfirm={handleAddSample}
			/>
		</ModalBase>
	);

	function handleAddSample(sample, language) {
		setLastLanguage(language);
		onAddSample(sample);
	}
};

AddSampleModal.propTypes = {
	// Open state of modal
	isOpen: PropTypes.bool.isRequired,
	// The storage to which the sample will be added
	storage: PropTypes.object.isRequired,
	// Callback function on confirm the addition (added sample passed)
	onAddSample: PropTypes.func.isRequired,
	// Callback on close dialog request
	onRequestClose: PropTypes.func.isRequired,
};

export default AddSampleModal;
